import Vue from 'vue';
import Str from "./helpers/Str";

const components = require.context("./components", true, /\.vue$/i);
const globalDirs = ["auth", "elements", "forms", "layout", "pages"];
const globalDirsNoPrefix = ["elements", "forms", "layout"];

components.keys().map((key) => {
  if (key.search("/partials/") !== -1) {
    return;
  }

  const [, ...parts] = key.split("/");
  const dir = parts[0];

  // Remove .vue from component name
  parts[parts.length - 1] = parts[parts.length - 1].replace(".vue", "");

  // Ignore non-global components
  if (!globalDirs.includes(dir)) {
    return;
  }

  // Remove directory if not needed
  if (globalDirsNoPrefix.includes(dir)) {
    parts[0] = "";
  }

  let registerAs = parts.map((item) => Str.studlyCase(item)).join("");
  Vue.component(registerAs, components(key).default);
});
